export default "__VITE_ASSET__ClNWtJPJ__"